import {useState, useEffect} from "react";
import {IResponseInitiativeId} from "../pages/StateInitiative/StateInitiative.type";

const useFetchDataFintechById = (
  apiUrl: string,
  apiKey: string,
  initiativeId: string
) => {
  const [initiativeData, setInitiativeData] =
    useState<IResponseInitiativeId | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!initiativeId) return;

    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const url = new URL(`${apiUrl}/${initiativeId}`);
    url.searchParams.set("populate", "*");

    fetch(url.href, {method: "GET", headers})
      .then((response) => response.json())
      .then((data) => {
        setInitiativeData(data);
      })
      .catch((error) => {
        setError(error);
      });
  }, [apiUrl, apiKey, initiativeId]);

  return {initiativeData, error};
};

export default useFetchDataFintechById;
